import { httpGet, httpDel } from '@/tool/request/index';
import { createStreamRequest } from '@/tool/request/streamRequest-daly.js'
const streamRequest = createStreamRequest();


type requestParams = {
  query: string
  inputs?: object
  user?: string
  response_mode: 'streaming' | 'blocking'
  conversation_id: string | null,
  tokenKey?: string
}

//获取的我的任务
export async function xcxTaskTask(params) {
  return await httpGet<API.RootResponse>('/xcx/task/task')({
    params,
  });
}

//获取我的上报
export async function xcxTaskReport(params) {
  return await httpGet<API.RootResponse>('/xcx/task/report')({
    params,
  });
}
//获取所有系统列表下拉框
export async function baseGetSystems() {
  return await httpGet<API.RootResponse>('/base/getSystems')({});
}
//获取我的上报详情
export async function xcxTaskReportDetail(params) {
  return await httpGet<API.RootResponse>('/xcx/task/report/detail')({
    params,
  });
}
//删除我的上报
export async function xcxTaskReportDelete(reportId) {
  return await httpDel<API.RootResponse>('/xcx/task/report')({
    params: { reportId },
    isUrlQs: true,
  });
}
//每日简报水质监测 指标与参考值数据
export async function xcxTaskGetTemplates(params) {
  return await httpGet<API.RootResponse>('/xcx/task/getTemplates')({
    params,
  });
}
//获取批次下拉框列表
export async function xcxTaskBatchList(params) {
  return await httpGet<API.RootResponse>('/xcx/task/batchList')({ params });
}

//获取基地下拉框列表
export async function xcxTaskBase() {
  return await httpGet<API.RootResponse>('/xcx/task/base')({});
}
//获取批次下拉框列表
export async function xcxWaterGetCurrDay(params) {
  return await httpGet<API.RootResponse>('/xcx/task/report/water')({
    params,
  });
}

//获取日报关联数据
export async function xcxTaskEverydayReportLog(params) {
  return await httpGet<API.RootResponse>('/xcx/task/report/log')({
    params,
  });
}

// /user/list 获取基地下所有的人员
export async function xcxUserList() {
  return await httpGet<API.RootResponse>('/user/allList')();
}

// 日报ai分析
export async function dailyAIinterpret(data: requestParams, callback: (_error: any, _success: any) => void) {
  let _error = null;
  streamRequest.request({
    url: '/chat-messages',
    method: "POST",
    data: {
      ...data,
      response_mode: "streaming",
      inputs: data.inputs ?? {},
      "user": "928044336@qq.com",
      tokenKey: data.tokenKey
    },
    onMessage: (data: any) => {
      callback(_error, data)
    },
    onError: (err: any) => {
      _error = err;
      callback?.(_error, null)
    },

  });

  return streamRequest
}

// 终止响应
export async function stopResponse() {
  streamRequest.abort()
}


